module.exports = __webpack_public_path__ + "static/media/check.db241c05.svg";